import {
  Checkbox,
  Divider,
  Grid,
  LinearProgress,
  Typography,
  Radio,
  RadioGroup,
  FormControl,
  FormControlLabel,
} from '@mui/material';
import React, { useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Loader } from '../../../../Common/Components/Loader';
import { azureDevOpsService } from '../../AzureDevOps/AzureDevOpsService';
import {
  BaseDeployment,
  DeploymentFooter,
  DeploymentTypeComponent,
} from '../../AzureDevOps/Common/CommonMethod';
import { AssembleBuild } from '../../AzureDevOps/Model/AzureDevOpsModel';
import { CardWrapper, PaperWrapper } from '../../Common/CommonComponents';
import { customerService } from '../../Customer/CustomerService';
import { CustomerV2 } from '../../Customer/Model/CustomerModel';
import { farmService } from '../../Farm/FarmService';
import { Farm, Tenant } from '../../Farm/Model/FarmModel';
import FarmContants from '../Model/FarmConstants';
import {
  AssembleFilterType,
  DeploymentSourceType,
  ReleaseRequest,
} from '../Model/FarmModel';
import { showToast } from '../../../../lib/toast';

interface Param {
  FarmId: string;
}

interface Component {
  name: string;
  checked: boolean;
  label: string;
}
interface TenantCheck extends Component {
  customer: CustomerV2;
}
export default function DeployFarm() {
  const param = useParams<Param>();
  const initialTenants: Tenant[] = [];
  const [farm, setFarm] = React.useState<Farm>();
  const history = useHistory();

  const [components, setComponents] = React.useState<Component[]>([
    { name: 'PA.Api', checked: true, label: 'Api' },
    { name: 'PA.Appserver', checked: true, label: 'Appserver' },
    { name: 'PA.Dss', checked: true, label: 'Dss' },
    { name: 'PA.Gateway', checked: true, label: 'Gateway' },
    { name: 'PA.Web', checked: true, label: 'Old BIF Web' },
    { name: 'WebApp', checked: true, label: 'React Web Admin' },
    { name: 'SetupDB', checked: true, label: 'SetupDB' },
    { name: 'PA.newweb', checked: true, label: 'New Web' },
    { name: 'PA.bff', checked: true, label: 'BFF' },
    { name: 'PA.Functions', checked: false, label: 'Functions' },
    { name: 'Ascertra.Search', checked: true, label: 'Azure AI Search' },
  ]);

  const initialassemblebuilds: AssembleBuild[] = [];
  const initialSelectedList: TenantCheck[] = [];

  const [assemblebuilds, setAssemblebuilds] = useState(initialassemblebuilds);
  const [assemblebuildscopy, setAssemblebuildscopy] = useState(
    initialassemblebuilds,
  );
  const [branches, setBranches] = useState<string[]>([]);
  const [platformBranches, setPlatformBranches] = useState<string[]>([]);
  const [selectedBranch, setSelectedBranch] = useState('refs/heads/master');
  const [selectedPlatformBranch, setSelectedPlatformBranch] =
    useState('refs/heads/master');
  const [selectedList, setSelectedList] = useState(initialSelectedList);
  const [tenants, setTenants] = useState(initialTenants);
  const [selectAllTenants, setSelectAllTenants] = useState(false);
  const [selectAllComponents, setSelectAllComponents] = useState(false);
  const [selectedAssembleBuild, setSelectedAssembleBuild] =
    useState<string>('');
  const [assembleBuild, setAssembleBuild] = useState('');
  const [disasterrecovery, setDisasterrecovery] = useState(false);
  const [rollback, setRollback] = useState(false);
  const [DeployOnly, setDeployOnly] = useState(false);
  const [selectedlistLoading, setselectedlistLoading] = useState(true);
  const [filterType, setFilterType] = useState<AssembleFilterType>(
    AssembleFilterType.AssembleName,
  );
  const [deploymentSourceType, setDeploymentSourceType] =
    useState<DeploymentSourceType>(DeploymentSourceType.Latest);
  const [releaseTags, setReleaseTags] = useState<string[]>([]);
  const [selectedReleaseTag, setSelectedReleaseTag] = useState<string>('');

  const [loading, setLoading] = useState(false);

  const handleDeploymentSourceTypeChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const newSourceType = event.target.value as DeploymentSourceType;
    setDeploymentSourceType(newSourceType);
    // Reset selections when switching source type
    setSelectedAssembleBuild('');
    setSelectedReleaseTag('');
    setSelectedBranch('refs/heads/master');
  };

  const onTypeFilterChange = (filterType: AssembleFilterType) => {
    setFilterType(filterType);
    if (filterType === AssembleFilterType.Tag) {
      removeNulTags();
    }
  };

  const removeNulTags = () => {
    setAssemblebuilds((prev) =>
      prev.filter(
        (item) =>
          item.Tags[0] !== null &&
          item.Tags[0] !== undefined &&
          item.Tags[0] !== '',
      ),
    );
  };

  const handleSearchFilter = (searchFilterText: string) => {
    const lowerSearch = searchFilterText.toLowerCase();
    let filteredAB = assemblebuildscopy;

    if (searchFilterText.trim() !== '') {
      if (filterType === AssembleFilterType.Tag) {
        filteredAB = assemblebuildscopy.filter((ab) =>
          ab.Tags?.some((tag) => tag?.toLowerCase().includes(lowerSearch)),
        );
      } else if (filterType === AssembleFilterType.AssembleName) {
        filteredAB = assemblebuildscopy.filter((ab) =>
          ab.BuildNumber?.toLowerCase().includes(lowerSearch),
        );
      }
    }
    removeNulTags();

    setAssemblebuilds(filteredAB);
  };

  function handleFieldChange(event: React.ChangeEvent<HTMLInputElement>) {
    const value = event.target.value;
    if (event.target.name === 'AssembleBuild') {
      setAssembleBuild(value.toLowerCase());
      handleSearchFilter(value);
    } else if (event.target.name === 'SelectedAssemble') {
      setSelectedAssembleBuild(value);
    } else if (event.target.name === 'SelectedBranch') {
      setSelectedBranch(value);
    } else if (event.target.name === 'SelectedPlatformBranch') {
      setSelectedPlatformBranch(value);
    } else if (event.target.name === 'SelectedReleaseTag') {
      setSelectedReleaseTag(value);
      // When a release tag is selected, find and set the corresponding assemble build
      const matchingBuild = assemblebuildscopy.find((build) =>
        build.Tags?.includes(value),
      );
      if (matchingBuild) {
        setSelectedAssembleBuild(matchingBuild.BuildNumber);
      }
    }
  }
  function handleCheckbox(event: React.ChangeEvent<HTMLInputElement>) {
    if (event.target.name === 'SelectAllTenants') {
      setSelectAllTenants(event.target.checked);
      selectedList.forEach((tenant) => {
        tenant.checked = event.target.checked;
      });
    }
    if (event.target.name === 'SelectAllComponents') {
      setSelectAllComponents(event.target.checked);
      const updatedComponents = components.map((component) => ({
        ...component,
        checked: event.target.checked,
      }));
      setComponents(updatedComponents);
      return;
    }
    const updatedComponents = components.map((component) =>
      component.name === event.target.name
        ? { ...component, checked: event.target.checked }
        : component,
    );
    const updatedTenants = selectedList.map((tenant) =>
      tenant.name === event.target.name
        ? { ...tenant, checked: event.target.checked }
        : tenant,
    );
    setComponents(updatedComponents);
    setSelectedList(updatedTenants);
  }
  React.useEffect(() => {
    loadInitData();
  }, []);

  React.useEffect(() => {
    if (tenants.length > 0) {
      getselectedList(tenants);
    }
  }, [tenants]);

  const loadInitData = async () => {
    if (tenants.length < 1) {
      loadTenants();
    }
    await loadAssembles();
    await loadBranches();
    await loadPlatformBranches();
    await loadFarm();
  };
  const loadAssembles = async () => {
    try {
      setLoading(true);
      const assemblebuilds = await azureDevOpsService.getBuild();
      const lowercasedBuilds = assemblebuilds.map((build) => ({
        ...build,
        BuildNumber: build.BuildNumber?.toLowerCase(),
        Tags: build.Tags?.map((tag) => tag?.toLowerCase()),
      }));
      setAssemblebuilds(lowercasedBuilds);
      setAssemblebuildscopy(lowercasedBuilds);
      // Extract unique tags for release selection
      const uniqueTags = Array.from(
        new Set(
          lowercasedBuilds
            .flatMap((build) => build.Tags)
            .filter(
              (tag): tag is string =>
                tag !== null && tag !== undefined && tag !== '',
            ),
        ),
      );
      setReleaseTags(uniqueTags);
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };
  const loadBranches = async () => {
    try {
      setLoading(true);
      const response = await azureDevOpsService.getProarcSetupBranches();
      const branchItems = Array.isArray(response)
        ? response
        : response?.Items ?? [];
      setBranches(branchItems.map((branch: string) => branch.toLowerCase()));
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };
  const loadPlatformBranches = async () => {
    try {
      setLoading(true);
      const branches = await azureDevOpsService.getBranches();
      setPlatformBranches(branches.Items);
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };
  const loadFarm = async () => {
    try {
      const farm = await farmService.getFarm(param.FarmId);
      setFarm(farm);
    } catch (error) {
      console.log(error);
    }
  };
  const loadTenants = async () => {
    try {
      await farmService.getTenantsOnFarm(+param.FarmId).then((newtenants) => {
        setTenants(newtenants.Items);
      });
    } catch (error) {
      console.log(error);
    }
  };

  const getselectedList = async (tenants: Tenant[]) => {
    try {
      const newSelectedItems: TenantCheck[] = [];

      for (const element of tenants) {
        const data = await customerService.getCustomer(element.Id);

        if (data.Id !== undefined) {
          newSelectedItems.push({
            name: data.Id,
            checked: false,
            label: data.Subdomain ?? data.Id,
            customer: data,
          });
        }
      }

      setSelectedList((prevSelectedList) => [
        ...prevSelectedList,
        ...newSelectedItems,
      ]);
      setselectedlistLoading(false);
    } catch (error) {
      console.log(error);
    }
  };
  const RenderCheckbox = (props: {
    name: string;
    checked: boolean;
    label: string;
  }) => {
    return (
      <div
        style={{
          display: 'block',
          marginRight: '20px',
        }}
      >
        <Checkbox
          checked={props.checked}
          color="primary"
          inputProps={{ 'aria-label': 'secondary checkbox' }}
          name={props.name}
          onChange={handleCheckbox}
        />
        <label>{props.label}</label>
      </div>
    );
  };

  const DeployAppServices = () => {
    const Release: ReleaseRequest = {};
    const selectedlist = selectedList
      .filter(function (obj) {
        return obj.checked;
      })
      .map(function (obj) {
        return obj?.customer?.Id;
      })
      .filter((item): item is string => item !== undefined);
    const compos = components
      .filter(function (obj) {
        return obj.checked;
      })
      .map(function (obj) {
        return obj.name;
      });

    Release.components = compos;
    Release.branch = selectedPlatformBranch;

    // Set buildID and deploymentVersion based on deployment source type
    if (deploymentSourceType === DeploymentSourceType.Latest) {
      // For Latest, leave buildID empty (blank)
      Release.buildID = '';
      Release.deploymentVersion = 'latest';
    } else if (deploymentSourceType === DeploymentSourceType.Release) {
      // For Release, use the build associated with the selected tag
      Release.buildID = selectedAssembleBuild;
      Release.deploymentVersion = `releases/${selectedReleaseTag.replace(/\s+/g, '')}`;
    } else {
      // For Branch, use the selected branch name (without refs/heads/ prefix)
      Release.buildID = selectedAssembleBuild;
      Release.deploymentVersion = selectedBranch.replace(/^refs\/heads\//, '');
    }

    if (selectedlist.length < 1) {
      showToast({
        type: 'info',
        title: FarmContants.EmptyTenantInfo,
      });
    } else if (compos.length < 1) {
      showToast({
        type: 'info',
        title: FarmContants.EmptyComponentInfo,
      });
    } else if (
      deploymentSourceType === DeploymentSourceType.Release &&
      selectedReleaseTag === ''
    ) {
      showToast({
        type: 'info',
        title: FarmContants.EmptyBuildInfo,
      });
    } else {
      Release.tenantIds = selectedlist;
      Release.farmId = farm?.Id;
      Release.deployOnly = DeployOnly;
      Release.disasterRecovery = disasterrecovery;
      CreateRelease(Release);
      history.push('/farm');
    }
  };

  const CreateRelease = async (Release: ReleaseRequest) => {
    try {
      azureDevOpsService.CreateRelease(Release);
      showToast({
        type: 'success',
        title: FarmContants.DeploymentQueued,
      });
    } catch (error) {
      console.error('Error creating release:', error);
      showToast({
        type: 'error',
        title: FarmContants.DeploymentQueueFailed,
      });
    }
  };

  return (
    <div>
      <PaperWrapper>
        <Typography variant="h5" sx={{ mb: 2 }}>
          Deploy Farm: {farm?.DisplayName} - {farm?.Id}
        </Typography>
        <Divider sx={{ mb: 3 }} />
        <Loader loading={selectedlistLoading || loading} />
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <CardWrapper>
              <Typography variant="h6" gutterBottom sx={{ mb: 2 }}>
                Deployment Source
              </Typography>
              <Divider sx={{ mb: 3 }} />
              <FormControl>
                <RadioGroup
                  row
                  name="deployment-source-type"
                  value={deploymentSourceType}
                  onChange={handleDeploymentSourceTypeChange}
                >
                  <FormControlLabel
                    value={DeploymentSourceType.Latest}
                    control={<Radio />}
                    label="Latest"
                  />
                  <FormControlLabel
                    value={DeploymentSourceType.Release}
                    control={<Radio />}
                    label="Release"
                  />
                  <FormControlLabel
                    value={DeploymentSourceType.Branch}
                    control={<Radio />}
                    label="Branch"
                  />
                </RadioGroup>
              </FormControl>
            </CardWrapper>

            {deploymentSourceType === DeploymentSourceType.Release && (
              <CardWrapper sx={{ mt: 3 }}>
                <Typography variant="h6" gutterBottom sx={{ mb: 2 }}>
                  Release Tags
                </Typography>
                <Divider sx={{ mb: 3 }} />
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12} sm={6}>
                    <Typography variant="body1">Select Release Tag</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <BaseDeployment
                      assembleBuild={assembleBuild}
                      handleFieldChange={handleFieldChange}
                      assemblebuilds={assemblebuilds}
                      selectedassembleBuild={selectedAssembleBuild}
                      branches={branches}
                      selectedBranch={selectedBranch}
                      setFilterType={onTypeFilterChange}
                      filterType={filterType}
                      showOnlyTags={true}
                      releaseTags={releaseTags}
                      selectedReleaseTag={selectedReleaseTag}
                    />
                  </Grid>
                </Grid>
              </CardWrapper>
            )}

            {deploymentSourceType === DeploymentSourceType.Branch && (
              <CardWrapper sx={{ mt: 3 }}>
                <Typography variant="h6" gutterBottom sx={{ mb: 2 }}>
                  Branch Selection
                </Typography>
                <Divider sx={{ mb: 3 }} />
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12} sm={6}>
                    <Typography variant="body1">Select Branch</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <BaseDeployment
                      assembleBuild={assembleBuild}
                      handleFieldChange={handleFieldChange}
                      assemblebuilds={assemblebuilds}
                      selectedassembleBuild={selectedAssembleBuild}
                      branches={branches}
                      selectedBranch={selectedBranch}
                      setFilterType={onTypeFilterChange}
                      filterType={filterType}
                      showOnlyBranches={true}
                      releaseTags={releaseTags}
                      selectedReleaseTag={selectedReleaseTag}
                    />
                  </Grid>
                </Grid>
              </CardWrapper>
            )}

            {deploymentSourceType === DeploymentSourceType.Latest && (
              <CardWrapper sx={{ mt: 3 }}>
                <Typography variant="h6" gutterBottom sx={{ mb: 2 }}>
                  Build Details
                </Typography>
                <Divider sx={{ mb: 3 }} />
                <Typography variant="body2" color="textSecondary">
                  Using latest available build
                </Typography>
              </CardWrapper>
            )}

            <CardWrapper sx={{ mt: 3 }}>
              <Typography variant="h6" gutterBottom sx={{ mb: 2 }}>
                Platform Branch
              </Typography>
              <Divider sx={{ mb: 3 }} />
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} sm={6}>
                  <Typography variant="body1">
                    Select Platform Branch
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <BaseDeployment
                    assembleBuild={assembleBuild}
                    handleFieldChange={handleFieldChange}
                    assemblebuilds={assemblebuilds}
                    selectedassembleBuild={selectedAssembleBuild}
                    branches={platformBranches}
                    selectedBranch={selectedPlatformBranch}
                    setFilterType={onTypeFilterChange}
                    filterType={filterType}
                    showOnlyBranches={true}
                    showOnlyPlatformBranches={true}
                    releaseTags={releaseTags}
                    selectedReleaseTag={selectedReleaseTag}
                  />
                </Grid>
              </Grid>
            </CardWrapper>

            <CardWrapper sx={{ mt: 3 }}>
              <Typography variant="h6" sx={{ mb: 2, fontWeight: 500 }}>
                Proarc Components
              </Typography>
              <Divider sx={{ mb: 2 }} />
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <RenderCheckbox
                    checked={selectAllComponents}
                    label={'Select All'}
                    name={'SelectAllComponents'}
                  />
                </Grid>
                {components.map((component) => (
                  <Grid item xs={12} sm={6} md={4} key={component.name}>
                    <RenderCheckbox
                      name={component.name}
                      checked={component.checked}
                      label={component.label}
                    />
                  </Grid>
                ))}
              </Grid>
            </CardWrapper>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <CardWrapper>
              <Typography variant="h6" sx={{ mb: 2, fontWeight: 500 }}>
                Deployment Type (Leave empty for default)
              </Typography>
              <Divider sx={{ mb: 2 }} />
              <DeploymentTypeComponent
                disasterrecovery={disasterrecovery}
                rollback={rollback}
                DeployOnly={DeployOnly}
                handleCheckbox={handleCheckbox}
                setDeployOnly={setDeployOnly}
                setRollback={setRollback}
                setDisasterrecovery={setDisasterrecovery}
                displayOptions={{
                  deployOnly: true,
                  rollback: true,
                  disasterRecovery: true,
                }}
              />
            </CardWrapper>

            <CardWrapper sx={{ mt: 3 }}>
              <Typography variant="h6" sx={{ mb: 2, fontWeight: 500 }}>
                Tenants to be Deployed
              </Typography>
              <Divider sx={{ mb: 2 }} />
              {selectedlistLoading ? (
                <LinearProgress />
              ) : (
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <RenderCheckbox
                      checked={selectAllTenants}
                      label={'Select All'}
                      name={'SelectAllTenants'}
                    />
                  </Grid>
                  {selectedList.map((tenant) => (
                    <Grid item xs={12} sm={6} md={4} key={tenant.name}>
                      <RenderCheckbox
                        name={tenant.name}
                        checked={tenant.checked}
                        label={tenant.label}
                      />
                    </Grid>
                  ))}
                </Grid>
              )}
            </CardWrapper>
          </Grid>
        </Grid>
        <DeploymentFooter DeployAppServices={DeployAppServices} />
      </PaperWrapper>
    </div>
  );
}
